<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormOrdenCompra" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Proveedor">Proveedor</label>
                                                <div class="input-group">
                                                    <input disabled v-model="objOrdenCompra.Proveedor" id="Proveedor" type="text" class="form-control" placeholder="Ingresar Proveedor">
                                                    <CValidation v-if="this.errorvalidacion.Proveedor" :Mensaje="'*'+errorvalidacion.Proveedor[0]"/>
                                                    <button @click="AbrirModalRequisicion" class="btn btn-outline-primary boder-extend" type="button"><i class="fas fa-search"></i></button>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Contacto">Contacto</label>
                                                <input disabled v-model="objOrdenCompra.Contacto" id="Contacto" type="text" class="form-control" placeholder="Ingresar Contacto">
                                                <CValidation v-if="this.errorvalidacion.Contacto" :Mensaje="'*'+errorvalidacion.Contacto[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="CorreoContacto">Correo</label>
                                                <input disabled v-model="objOrdenCompra.CorreoContacto" id="CorreoContacto" type="text" class="form-control" placeholder="Ingresar Correo del Contacto">
                                                <CValidation v-if="this.errorvalidacion.CorreoContacto" :Mensaje="'*'+errorvalidacion.CorreoContacto[0]"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                                <label for="Requisicion">Requisición</label>
                                                <input disabled v-model="RequisicionSeleccionada.Folio" id="Requisicion" type="text" class="form-control" placeholder="Ingresar Requisicion">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                                <label for="Contacto">Fecha de Entrega</label>
                                                <div class="calendar">
                                                    <Datepicker v-model="objOrdenCompra.FechaEntrega" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
                                                </div>
                                                <CValidation v-if="this.errorvalidacion.FechaEntrega" :Mensaje="'*'+errorvalidacion.FechaEntrega[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="ContactoRef">Recibe</label>
                                                <input v-model="objOrdenCompra.ContactoRef" id="ContactoRef" type="text" class="form-control" placeholder="Ingresar Contacto Que Recibe">
                                                <CValidation v-if="this.errorvalidacion.ContactoRef" :Mensaje="'*'+errorvalidacion.ContactoRef[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="DepartamentoSolicitante">Departamento Solicitante</label>
                                                <input disabled v-model="RequisicionSeleccionada.Departamento" type="text" id="DepartamentoSolicitante" class="form-control" placeholder="Ingresar Departamento Solicitante">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="CondicionDePago">Condicion De Pago</label>
                                                <input v-model="objOrdenCompra.CondicionDePago" id="CondicionDePago" type="text" class="form-control" placeholder="Ingresar Contacto Que Recibe">
                                                <CValidation v-if="this.errorvalidacion.CondicionDePago" :Mensaje="'*'+errorvalidacion.CondicionDePago[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="MetodoPago">Metodo de Pago</label>
                                                <select v-model="objOrdenCompra.MetodoPago" class="form-control-search form-select" id="MetodoPago">
								                    <option value="">Seleccione una Categoría</option>
								                    <option v-for="(item, index) in MetodosPago" :key="index" :value="item.Nombre">{{item.Clave + ' - ' + item.Nombre}}</option>
							                    </select>
                                                <CValidation v-if="this.errorvalidacion.MetodoPago" :Mensaje="'*'+errorvalidacion.MetodoPago[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="FormaPago">Forma de Pago</label>
                                                <select v-model="objOrdenCompra.FormaPago" class="form-control-search form-select" id="FormaPago">
								                    <option value="">Seleccione una Categoría</option>
								                    <option v-for="(item, index) in FormasPago" :key="index" :value="item.Nombre">{{item.Clave + ' - ' + item.Nombre}}</option>
							                    </select>
                                                <CValidation v-if="this.errorvalidacion.FormaPago" :Mensaje="'*'+errorvalidacion.FormaPago[0]"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                                <label for="Moneda">Moneda</label>
                                                <select v-model="objOrdenCompra.Moneda" class="form-control-search form-select" id="Moneda">
								                    <option value="">Seleccione una Categoría</option>
								                    <option v-for="(item, index) in Monedas" :key="index" :value="item.Nombre">{{item.Clave + ' - ' + item.Nombre}}</option>
							                    </select>
                                                <CValidation v-if="this.errorvalidacion.Moneda" :Mensaje="'*'+errorvalidacion.Moneda[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                                <label for="UsoCFDI">Uso CFDI</label>
                                                <select v-model="objOrdenCompra.UsoCFDI" class="form-control-search form-select" id="UsoCFDI">
								                    <option value="">Seleccione una Categoría</option>
								                    <option v-for="(item, index) in UsosCFDI" :key="index" :value="item.Nombre">{{item.Clave + ' - ' + item.Nombre}}</option>
							                    </select>
                                                <CValidation v-if="this.errorvalidacion.UsoCFDI" :Mensaje="'*'+errorvalidacion.UsoCFDI[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                <label for="Observaciones">Observaciones</label>
                                                <textarea v-model="objOrdenCompra.Observaciones" id="Observaciones" cols="30" rows="3" class="form-control"></textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="table-responsive">
                                                    <table class="table align-items-center mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Cantidad</th>
                                                                <th>Material</th>
                                                                <th>Unidad</th>
                                                                <th>Sub Unidad</th>
                                                                <th>Descripción</th>
                                                                <th>Precio Unit.</th>
                                                                <th>Importe</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item,index) in MaterialesSeleccionados" :key="index">
                                                                <td>
                                                                    <input disabled v-model="item.Cantidad" type="text" class="form-control">
                                                                </td>
                                                                <td>
                                                                    <textarea disabled v-model="item.Material" class="form-control" cols="30" rows="3"></textarea>
                                                                    <!-- <input disabled v-model="item.Material" type="text" class="form-control"> -->
                                                                </td>
                                                                <td>
                                                                    <input disabled v-model="item.Unidad" type="text" class="form-control">
                                                                </td>
                                                                <td>
                                                                    <input disabled v-model="item.SubUnidad" type="text" class="form-control">
                                                                </td>
                                                                <td>
                                                                    <textarea disabled v-model="item.Descripcion" class="form-control" cols="30" rows="3"></textarea>
                                                                    <!-- <input disabled v-model="item.Descripcion" type="text" class="form-control"> -->
                                                                </td>
                                                                <td>
                                                                    <input disabled v-model="item.PrecioUnitario" type="text" class="form-control">
                                                                </td>
                                                                <td>
                                                                    <input disabled v-model="item.Importe" type="text" class="form-control">
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group form-row">
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-9">
                                                        <div class="row">
                                                            <label class="col-lg-8 col-form-label"></label>
                                                            <label class="col-lg-1 col-form-label text-right" style="padding-left:0;">
                                                                Descuento %
                                                            </label>
                                                            <div class="col-2 col-sm-12 col-lg-2">
                                                                <input disabled v-model="objOrdenCompra.DescPorcent" type="text" class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="row mb-3">
                                                           <label for="" class="col-lg-4 col-form-label">Descuento $:</label>
                                                           <div class="col-lg-7">
                                                            <input v-model="objOrdenCompra.Descuento" disabled type="text" class="form-control form-control-sm">
                                                           </div> 
                                                        </div>

                                                        <div class="row mb-3">
                                                            <label for="" class="col-lg-4 col-form-label">Sub Total:</label>
                                                            <div class="col-lg-7">
                                                             <input v-model="objOrdenCompra.SubTotal" disabled type="text" class="form-control form-control-sm">
                                                            </div> 
                                                         </div>

                                                         <div class="row mb-3">
                                                            <label for="" class="col-lg-4 col-form-label">I.V.A.:</label>
                                                            <div class="col-lg-7">
                                                             <input v-model="objOrdenCompra.ValorIva" disabled type="text" class="form-control form-control-sm">
                                                            </div> 
                                                         </div>

                                                         <div class="row">
                                                            <label for="" class="col-lg-4 col-form-label">Total:</label>
                                                            <div class="col-lg-7">
                                                             <input v-model="objOrdenCompra.Total" disabled type="text" class="form-control form-control-sm">
                                                            </div> 
                                                         </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <CBtnSave :poBtnSave="oBtnSave"></CBtnSave>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModalRequisicion" :poBtnSave="oBtnSaveRequisicion">
            <template slot="Form">
                <FormRequisicion :poBtnSave="oBtnSaveRequisicion"></FormRequisicion>
            </template>
        </CModal>
    </div>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';
import FormRequisicion from '../ordenCompra/RequisicionesModal.vue';
const EmitEjecuta = 'seccionOrdenCompra';
const EmitEjecuta2 = 'seccionRequisicion';
export default {
    name: 'FormOrdenCompra',
    props: ['Id'],
    components:{
        FormRequisicion,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Orden de Compra',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModalRequisicion:{
                ModalTitle: "Asignar Requisicion",
                ModalNameId: 'ModalFormRequisicion',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'xl',
                ShowFooter:false
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'OrdenCompra',
                EmitSeccion: EmitEjecuta,
                ShowBtnSave:true
            },
            oBtnSaveRequisicion:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            objOrdenCompra:{
                IdOrdenCompra:0,
                Folio:'',
                IdProveedor:0,
                Proveedor:'',
                Contacto:'',
                CorreoContacto:'',
                FechaExp:'',
                FechaEntrega:'',
                CondicionDePago:'',
                ContactoRef:'',
                FormaPago:'',
                ClavePago:'',
                MetodoPago:'',
                Moneda:'',
                UsoCFDI:'',
                Observaciones:'',
                Elaboro:0,
                Autorizo:0,
                FechaAutorizacion:'',
                DescPorcent:'',
                Descuento:0,
                SubTotal:0,
                Iva:0.16,
                ValorIva:0,
                Total:0,
                IdRequisicion:0,
                Estatus:'',
                Materiales:''
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            Setpicker:Calendar.calendarSettings,
            MetodosPago:[],
            FormasPago:[],
            Monedas:[],
            UsosCFDI:[],
            RequisicionSeleccionada:{},
            MaterialesSeleccionados:[],
            BuscarRequisicion:true,
        }
    },
    methods: {
        async Guardar(){
            this.errorvalidacion=[];
            this.oBtnSave.DisableBtn = true;
            let BndError=false;
            let Mensaje="";
            if(this.MaterialesSeleccionados.length==0){
                Mensaje='Debe Seleccionar Una Requisición';
                BndError=true;
            }
            if (BndError) {
                this.$toast.warning(Mensaje);
                this.oBtnSave.DisableBtn = false;
                return false;
            }
            let FechaEntrega='';
            let FechaOriginal=this.objOrdenCompra.FechaEntrega;
            if (this.objOrdenCompra.FechaEntrega!='' && this.objOrdenCompra.FechaEntrega!=undefined) {
                let day=this.objOrdenCompra.FechaEntrega.getDate();
                let month=this.objOrdenCompra.FechaEntrega.getMonth()+1;
                let year=this.objOrdenCompra.FechaEntrega.getFullYear();
                FechaEntrega=year+'-'+month+'-'+day;   
            }
            this.objOrdenCompra.FechaEntrega=FechaEntrega;
            this.objOrdenCompra.Materiales=JSON.stringify(this.MaterialesSeleccionados);
            this.objOrdenCompra.IdRequisicion=this.RequisicionSeleccionada.IdRequisicion;
            this.objOrdenCompra.IdProveedor=this.RequisicionSeleccionada.IdProveedor;
            if (this.objOrdenCompra.IdOrdenCompra==0) {
                this.$http.post("ordenCompra",this.objOrdenCompra
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.objOrdenCompra.FechaEntrega=FechaOriginal;
                    this.EjecutaConError(err);
                })
            }
            else{
                this.$http.put("ordenCompra/"+this.objOrdenCompra.IdOrdenCompra,this.objOrdenCompra
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.objOrdenCompra.FechaEntrega=FechaOriginal;
                    this.EjecutaConError(err);
                })
            }
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get('ordenCompra/'+this.objOrdenCompra.IdOrdenCompra
            ).then((res)=>{
                this.objOrdenCompra=res.data.data;
                let formatedDate = this.objOrdenCompra.FechaEntrega.replace(/-/g, "\/");
                this.objOrdenCompra.FechaEntrega=new Date(formatedDate);
                this.RequisicionSeleccionada=res.data.data.requisiciones;
                this.MaterialesSeleccionados=res.data.data.orden_compra_detalle;
                if (res.data.data.Estatus=="Solicitando") {
                    this.oBtnSave.ShowBtnSave=false;
                }
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar(){

        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        ListaCFDI(){
            this.$http.get("ordenCompraCFDI"
            ).then((res)=>{
                this.MetodosPago=res.data.data.MetodosPago;
                this.FormasPago=res.data.data.FormasPago;
                this.Monedas=res.data.data.Monedas;
                this.UsosCFDI=res.data.data.UsosCFDI;
            })
        },
        AbrirModalRequisicion(){
            this.bus.$emit('NewModal_'+this.ConfigModalRequisicion.EmitSeccion,0);
        },
        SeleccionarRequisicion(item){
            this.RequisicionSeleccionada=item;
            this.objOrdenCompra.Proveedor=this.RequisicionSeleccionada.Proveedor;
            this.objOrdenCompra.Contacto=this.RequisicionSeleccionada.Contacto;
            this.objOrdenCompra.CorreoContacto=this.RequisicionSeleccionada.CorreoContacto;
            this.objOrdenCompra.DescPorcent=this.RequisicionSeleccionada.DescPorcent;
            this.objOrdenCompra.Descuento=this.RequisicionSeleccionada.Descuento;
            this.objOrdenCompra.SubTotal=this.RequisicionSeleccionada.SubTotal;
            this.objOrdenCompra.ValorIva=this.RequisicionSeleccionada.ValorIva;
            this.objOrdenCompra.Total=this.RequisicionSeleccionada.Total;
            this.MaterialesSeleccionados=this.RequisicionSeleccionada.requisiciones_detalle;
            this.bus.$emit('CloseModal_'+this.ConfigModalRequisicion.EmitSeccion);
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
        this.bus.$off('SeleccionarRequisicion');
    },
    mounted() {
        this.ListaCFDI();
        this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.Id!='') 
        {
            this.BuscarRequisicion=false;
            this.objOrdenCompra.IdOrdenCompra = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
        this.bus.$on('SeleccionarRequisicion',(item)=>{
            this.SeleccionarRequisicion(item);
        });
    },
}
</script>

<style>

</style>